const RelatoriosMain = () => import(/* webpackChunkName: "group-callcenter-relatorios" */ '../views/RelatoriosMain')
import relatoriosFilas from '../modules/Fila/_routes'
import relatoriosOperador from '../modules/operador/_routes'
import relatoriosDisponibilidade from '../modules/disponibilidade/_routes'

import {
  permissionsRelatorioDisponibilidade,
  permissionsRelatorioFila,
  permissionsRelatorioOperador,
} from '../../../utils/permissionsCallCenter'

export default [
  {
    path: 'relatorios',
    meta: {
      requiresAuth: true,
      permissions: [
        ...permissionsRelatorioFila,
        ...permissionsRelatorioDisponibilidade,
        ...permissionsRelatorioOperador,
      ],
    },
    component: RelatoriosMain,
    children: [...relatoriosFilas, ...relatoriosOperador, ...relatoriosDisponibilidade],
  },
]
